import { quickFlash } from "@/mocks/site";

export default function FlashTicker() {
  return (
    <section aria-label="实时快讯流" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-3 px-4 py-4 md:flex-row md:items-center md:gap-6 md:px-8">
        <span className="flex shrink-0 items-center gap-2 text-sm font-semibold text-primary-600">
          <span className="flex h-5 w-5 items-center justify-center">
            <span className="h-2.5 w-2.5 rounded-full bg-primary-500 animate-live-dot" />
          </span>
          实时快讯
        </span>
        <ul className="flex flex-1 flex-col divide-y divide-background-200 md:flex-row md:items-center md:divide-x md:divide-y-0">
          {quickFlash.slice(0, 3).map((item) => (
            <li key={item.id} className="flex items-start gap-3 py-2.5 md:flex-1 md:px-5 md:py-0">
              <span className="shrink-0 font-heading text-xs font-bold text-foreground-400">
                {item.time}
              </span>
              <span className="text-sm leading-snug text-foreground-800">{item.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}